import MathRect from "./rectangle.js";

export default MathRect;
